<template>
  <div>
    <Modal v-model="modalAgreement" width="900" :mask-closable="false">
      <p slot="header" style="color:#2b85e4;text-align:center;font-size:16px;">
        <span>VIP升级协议</span>
      </p>
      <div ref="print_vip_content" class="explain">
        <h4>甲方：{{agreementHeader.fristName}}</h4>
        <h4>
          <span>甲方：“众智云擎”</span>
          账号：{{agreementHeader.fristUserId}}<span style="padding-left: 5px;" v-if="agreementHeader.useridupdatedesc!==''">{{agreementHeader.useridupdatedesc}}</span><span v-else></span>
        </h4>
        <h4>乙方：四川众智云擎科技有限公司</h4>
        <h6>甲方购买乙方产品列表</h6>
        <Table :columns="columns" :data="data" show-summary size="small">
          <template slot-scope="{ row }" slot="number">
            <strong>{{row.number}}</strong>
          </template>
        </Table>
        <h2>通用条款</h2>
        <h3>一、关于服务</h3>
        <p>乙方为甲方提供服务的载体为“众智云擎”，网址为http://www.holywiser.com。</p>
        <p>
          乙方推荐甲方使用浏览器为：
          <img :src="logo+edge" class="logo" />
          <a href="Microsoft-edge:http://www.holywiser.com" target="_blank">Edge(微软Edge浏览器)</a>,
          <img :src="logo+edge_chrome" class="logo" />
          <a href="https://www.microsoft.com/en-us/edge" target="_blank">Edge(新版)</a>,
          <img :src="logo+chrome" class="logo" />
          <a href="https://www.google.cn/chrome/" target="_blank">Chrome(谷歌浏览器)</a>,
          <img :src="logo+firefox" class="logo" />
          <a href="https://www.firefox.com.cn/" target="_blank">Firefox(火狐浏览器)</a>
        </p>
        <p>乙方为甲方提供税收法规查询及云端工作系统服务，服务内容以“众智云擎”呈现的内容为限。</p>
        <h3>二、VIP升级服务的特别规定</h3>
        <h5>（一）VIP升级服务的具体类别及定价</h5>
        <p>以在线商城呈现及描述为准。</p>
        <h5>（二）VIP升级服务的购买基础</h5>
        <p>只有具备付费账号情形下，在账号服务有效期内，才能购买VIP升级服务。</p>
        <h5>（三）VIP升级服务的购买期限</h5>
        <p>VIP升级服务的购买期限由甲方根据在线商城提示进行选择确定。</p>
        <h5>（四）VIP升级服务的续费前提</h5>
        <p>仅当账号续费成功后，VIP升级服务才能续费。</p>
        <h3>三、知识产权</h3>
        <p>乙方享有“众智云擎”完整的知识产权（包括但不限于发明、外观、软著、商标等），甲方充分尊重并保证不得以任何方式损害乙方知识产权及相关权益。</p>
        <h3>四、信息条款</h3>
        <p>双方充分信任并保证不滥用服务过程中知悉的数据信息。</p>
        <h3>五、权利义务</h3>
        <h5>（一）甲方权利与义务</h5>
        <p>1.甲方有权获取约定服务；</p>
        <p>2.甲方应及时足额支付服务费；</p>
        <p>3.甲方不以爬虫等工具大量下载乙方法规数据库、不得允许第三人使用其账号或者以其他不正当方式使用乙方服务。</p>
        <h5>（二）乙方权利与义务</h5>
        <p>1.乙方有权收取约定服务费用；</p>
        <p>2.乙方应及时更新税收法规数据库；</p>
        <p>3.因乙方原因造成服务中断的，相应延长服务期限。</p>
        <h3>六、款项支付及发票开具</h3>
        <h5>（一）款项支付</h5>
        <p>甲方可选择微信或者支付宝完成支付。</p>
        <h5>（二）发票开具</h5>
        <p>甲方应依法选择发票种类（专/普票），在完成支付前通过在线商城界面输入开票信息并保证信息真实合法。</p>
        <h3>七、违约责任</h3>
        <h5>（一）任何一方违约，守约方均可通知违约方，违约方应立即终止违约行为并采取补救措施；</h5>
        <h5>（二）因乙方原因中断服务的，乙方相应延长服务期；若因乙方原因中断服务满30日仍不能恢复服务的，甲方有权解除协议并要求乙方返还自中断服务之日起至服务期限届满止的服务费，若在此期间乙方恢复服务，甲方账号登录使用，则视为甲方放弃解除权，乙方相应延长服务期。</h5>
        <h5>（三）违约方应在终止违约行为的同时向守约方支付本协议项下服务费20%的违约金，该违约金的支付不免除任何其他侵权责任。</h5>
        <h3>八、免责条款</h3>
        <p>基于互联网和计算机技术的现状（包括但不限于网络传输技术、信息源、代码技术、程序技术、文字识别处理技术等）及可能引发的技术缺陷与瑕疵的理解与认同，甲方认可并接受下述情形：</p>
        <h5>（一）“众智云擎”是基于互联网提供服务的，因此，基于网络运营商的原因，可能造成甲方访问速率下降。</h5>
        <h5>（二）由于配合政府相关部门的工作，可能造成甲方无法访问“众智云擎”。</h5>
        <h5>（三）因自然原因或者政治因素等不可抗力的原因，甲方可能无法访问使用“众智云擎”，在不可抗力原因消除后，乙方需尽快修复系统并相应延长服务期。</h5>
        <h5>（四）乙方在其能力所及之范围内尽力保护甲方使用“众智云擎”过程中的计算机安全，但由于互联网的开放性、风险性以及技术缺陷，甲方在使用“众智云擎”的过程中，依然存在可能遭受第三方计算机病毒、恶意软件、恶意程序、恶意代码等侵害的风险。</h5>
        <h5>（五）“众智云擎”的信息服务内容来源于互联网，通过底层架构、逻辑结构的设计，经计算机技术与人工共同筛选、判断、复核， 尽量确保信息的准确、完整、及时，但基于技术与人力的现状，仍无法对信息内容的完整性与准确性做出绝对性承诺，任何正式使用乙方税收法规库的情形，仍需与官方文本比对。</h5>
        <h5>（六）“众智云擎”的信息服务内容来源于互联网，不代表乙方及其任何关联方的意见，也不构成乙方及其任何关联方的建议。</h5>
        <p>因上述情形，乙方及其任何关联方不承担甲方任何直接或者间接损失，甲方表示接受与理解。</p>
        <h3>九、争议解决</h3>
        <p>双方同意如下争议解决方式：</p>
        <h5>（一）首先由双方协商解决；</h5>
        <h5>（二）无法协商的，鉴于乙方提供互联网信息服务，由乙方所在地法院诉讼解决。</h5>
        <h3>十、其他</h3>
        <h5>（一）甲方确认支付，即视为同意并签订本协议；当日支付，次日计算服务期；本协议未约定的，以甲方与乙方在线签订的《用户协议》为准；</h5>
        <h5>（二）未尽事宜，双方协商一致，可签订补充协议；</h5>
        <h5>（三）本协议以电子文本形式存在，具有法律效力；</h5>
        <h5>（四）甲方可点击账号下的“账号中心”，查阅、打印协议；甲方应自支付完成之日起90日内通过“账号中心”再次确认发票信息并开具发票（超过90日未再次确认的，系统将按照甲方支付时确认的开票信息自动开具发票），发票开具后可查阅、打印。</h5>
        <br />
        <br />
        <h4>甲方：{{agreementHeader.fristName}}</h4>
        <h4>
          <span>甲方：“众智云擎”</span>
          账号：{{agreementHeader.fristUserId}}<span style="padding-left: 5px;" v-if="agreementHeader.useridupdatedesc!==''">{{agreementHeader.useridupdatedesc}}</span><span v-else></span>
        </h4>
        <br />
        <h4>乙方：四川众智云擎科技有限公司</h4>
        <br />
        <h4>签订时间：{{isShowSignDate?agreementHeader.signdatedesc:''}}</h4>
        <img :src="signStr" alt class="img-rules" v-show="showImg" @contextmenu.prevent />
      </div>
      <div slot="footer" style="text-align: center;">
        <Button
          type="primary"
          size="large"
          :style="{display:isConfirm?'inline-block':'none',width:'120px'}"
          @click="closeAgreement"
        >同意并继续</Button>
        <Button
          type="primary"
          size="large"
          :style="{display:isPrinter?'inline-block':'none',width:'120px'}"
          @click="goPrint"
        >打印</Button>
        <!--  <Button type="primary" size="large" @click="sumitClearDocs">确定</Button> -->
      </div>
    </Modal>
    <Printer ref="myprinter" />
  </div>
</template>
<script>
import PrintView from './iframe_printer.vue'
import res from '../../../public/resource/codeimg.json'
export default {
  name: 'product_package_Agreement',
  props: {
    isPrinter: {
      type: Boolean,
      default: false,
    },
    isConfirm: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      showImg: false, // 是否显示盖印
      isShowSignDate: false,
      imgroot: '/manual/',
      logo: '/manual/logo/',
      edge: 'microsoft_edge.png',
      edge_chrome: 'edge_chrome.png',
      chrome: 'google_chrome.png',
      firefox: 'mozilla_firefox.png',
      agreementHeader: {},
      modalAgreement: false,
      columns: [{
        title: '产品名称',
        key: 'productname',
      },
      {
        title: '产品描述',
        key: 'productdesc',
      },
      {
        title: '产品数量',
        slot: 'number',
      },
      {
        title: '服务期限',
        key: 'servicedatedesc',
      },
      {
        title: '服务费用（单位：元）',
        key: 'amount',
        width:'300'
      },
      ],
      data: [],
      signStr: res.signature
    }
  },
  components: {
    'Printer': PrintView,
  },
  mounted () { },
  methods: {
    goPrint () {
      let c = this.getPrintContent()
      this.$refs.myprinter.setBodyHtml2(c)
    },
    getPrintContent () {
      return this.$refs.print_vip_content.innerHTML
    },
    show () {
      this.modalAgreement = true
    },
    createdata (item, isShow = false) {
      this.agreementHeader = item
      this.isShowSignDate = isShow
      this.data = this.agreementHeader.detail
      console.log(this.agreementHeader)
    },
    closeAgreement () {
      this.$emit("onAccept")
      this.modalAgreement = false
    },
  }
}
</script>
<style scoped>
.explain {
  height: 600px;
  overflow: auto;
  position: relative;
}

h2 {
  line-height: 50px;
}

h3 {
  line-height: 40px;
}

h4 {
  line-height: 30px;
}

h5 {
  line-height: 30px;
}

h6 {
  line-height: 60px;
}

p {
  line-height: 23px;
  font-size: 12px;
}

span {
  /* padding-right: 20px; */
}
.logo {
  height: 13px;
  width: 13px;
  vertical-align: text-top;
}
.img-rules {
  height: 150px;
  width: 150px;
  position: relative;
  left: 50px;
  bottom: 95px;
}
</style>